import * as React from "react"

const Search = () => {
  return (
    <div>
     search 01
    </div>
  )
}

export default Search
